export default __webpack_public_path__ + "static/media/celular.591da9cc.png";